/* jslint browser: true */
import React, { Component } from 'react';

class Footer extends Component {
    componentWillMount() {}

    render() {
        return (
            <footer>
                <div className="company-infos">
                    <p>Laboratoire M.G.S Lucia Rapetti - Tél. + 33 (0)4 92 12 30 60</p>
                    <p>PRODUITS DE BEAUTÉ</p>
                </div>
                <div className="copyright">
                    <p>© Lucia Rapetti - NextSourcia - Version 1.803.28</p>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js